//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
let d=[[[1,"BooleanOption",0,"GeometricUtilities.BooleanOperation",0],[0,"BooleanType",1,0],[1,"Height",0,"Expression",0],[1,"Length",0,"Expression",0],[0,"Origin",1,0],[0,"OriginPoint",1,"Point",0],[0,"ParentAssociativity",1,0],[0,"PointFromOrigin",1,"Point",0],[0,"Target",1,"Body",0],[0,"Type",1,0],[1,"Width",0,"Expression",0]],[[["x_axis","y_axis"],"GetOrientation",{},0,0],[["length"],"SetLength",{},1,0],[["width"],"SetWidth",{},1,0],[["height"],"SetHeight",{},1,0],[["x_axis","y_axis"],"SetOrientation",{},2,0],[["origin_point","length_expression","width_expression","height_expression"],"SetOriginAndLengths",{},4,0],[["origin_point","corner_point","height_expression"],"SetTwoPointsAndHeight",{},3,0],[["origin_point","corner_point"],"SetTwoDiagonalPoints",{},2,0],[["boolean_operation","target_body"],"SetBooleanOperationAndTarget",{},2,0]],[]];
SPLM.Features.BlockFeatureBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.BlockFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.BlockFeatureBuilder.Types = Object.freeze({
    "OriginAndEdgeLengths" : "OriginAndEdgeLengths", "TwoPointsAndHeight" : "TwoPointsAndHeight", "DiagonalPoints" : "DiagonalPoints"});

export default SPLM;